/**
 * CrewViewPicker — supervisor/admin control on the Today / My Week screens that
 * picks which crew member's day/week to view. The selection is held in the URL
 * (?crew_member_id=), so it survives opening a task and coming back and is
 * shareable. Rendered only for managers; crew members never see it.
 */
import { useSearchParams } from 'react-router-dom';
import { Eye } from 'lucide-react';
import { useCrew } from '@/api/crew';

export function CrewViewPicker() {
  const [searchParams, setSearchParams] = useSearchParams();
  const selected = searchParams.get('crew_member_id') ?? '';
  const { data } = useCrew();
  const crew = data?.data ?? [];

  return (
    <label className="flex items-center gap-2 rounded-2xl border border-line bg-bg px-3 py-2 text-sm">
      <Eye className="h-4 w-4 shrink-0 text-ink-faint" />
      <span className="shrink-0 text-ink-dim">Viewing</span>
      <select
        value={selected}
        onChange={(e) => {
          const next = new URLSearchParams(searchParams);
          if (e.target.value) next.set('crew_member_id', e.target.value);
          else next.delete('crew_member_id');
          setSearchParams(next, { replace: true });
        }}
        className="min-w-0 flex-1 bg-transparent font-medium focus:outline-none"
      >
        <option value="">Select a crew member…</option>
        {crew.map((c) => (
          <option key={c.id} value={c.id}>
            {c.user.display_name}
            {c.crew_role ? ` · ${c.crew_role}` : ''}
          </option>
        ))}
      </select>
    </label>
  );
}
